import type { ReportsRepository } from "./ReportsRepository";
import { ApiReportsRepository } from "./ApiReportsRepository.ts";

export function getReportsRepository(): ReportsRepository {
  return new ApiReportsRepository();
}
